import React, { useState } from 'react'
import { Row, Container, Card, ListGroup, Breadcrumb, InputGroup, FormControl } from 'react-bootstrap'
import HeaderSupport from '../../Components/HeaderSupport'
import Bannersupport from '../../Assets/TempExample//ExampleGuides.png'
import ImageIconLoader from '../../Components/ImageIconLoader'
import Footer from '../../Components/FooterSupport'

const Index: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const handleSearch = (event: any) => {
    const term = event.target.value;
    setSearchTerm(term);
    if (term === '') {
    } else {
    }
  };
  return (
    <div className='position-relative'>
      <HeaderSupport />
      <div className='guides_banner'>
        <div className="guides_banner-container container-fluid ">
          <div className='px-4 col-4'>
            <div className='mx-3'>
              <Breadcrumb>
                <Breadcrumb.Item href="#">Suport</Breadcrumb.Item>
                <Breadcrumb.Item active>Documentation</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div>
              <h1 className=' text-white'>
                Documentation
              </h1>
              <p className='text-white'>
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod.
              </p>
              <InputGroup className="search-input">
                <FormControl
                  placeholder="Search"
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <InputGroup.Text className="search-icon">
                  <ImageIconLoader name={"iconsearch"} alt="" width={30} />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>

        </div>

      </div>
      <Container fluid>
        {['PES Markets', 'Predict Program Size', 'Geotargeting'].map((item) => (
          <section className='p-4'>
            {/* <div className='guide_header m-3'>
              <h4 className='guide_title_sec'>
                {item}
              </h4>
              <p className='guide_desc'>
                Dive into our series of interactive training guides designed to equip you with comprehensive knowledge and practical skills for navigating PES. Whether you’re seeking to refine your PES expertise or you’re just getting started, our immersive walk-throughs offer the perfect learning experience tailored to your needs.
              </p>
            </div> */}

            <div className='d-flex justify-content-between p-0'>


              {[1, 3].map(() => (
                <Card className='w-100 m-3 border-0'>
                  {/* <Card.Img variant="top" src={Bannersupport} /> */}
                  <Card.Body>
                    <Card.Title className='h3'>Lorem Ipsum</Card.Title>
                    <Card.Text className='guide_desc'>
                      Dive into our series of interactive training guides designed to equip you with comprehensive knowledge and practical skills for navigating PES. Whether you’re seeking to refine your PES expertise or you’re just g.... <span className='text-blue' >Learn more</span>
                    </Card.Text>
                  </Card.Body>
                </Card>
              ))}


            </div>
          </section >
        ))}
      </Container>


      <Footer />
    </div >
  )
}

export default Index